import React, { PureComponent, Fragment } from 'react';
import SvgRender from 'components/helpers/SvgRender';

import edit from 'assets/svg/actions/edit.svg';
import loader from 'assets/svg/loader.svg';
import remove from 'assets/svg/actions/cross.svg';
class ButtonIcon extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      icons: {
        edit,
        loader,
        remove
      }
    };
  }

  render() {
    const { icon, className, wrapperClassName, width, height } = this.props;

    return (
      <Fragment>
        {icon && this.state.icons[icon] ? (
          <SvgRender
            path={this.state.icons[icon]}
            style={{ height: height ? height : 16, width: width ? width : 16 }}
            className={className ? className : ''}
            wrapperClassName={wrapperClassName ? wrapperClassName : ''}
          />
        ) : null}
        {this.props.children}
      </Fragment>
    );
  }
}

export default ButtonIcon;



// WEBPACK FOOTER //
// ./src/components/helpers/ButtonIcon.js